/**
 * 管理端  客户管理
 */
 <template>
    <div class="login-page">
      <topInfo></topInfo>
      <sysNav></sysNav>
      <!-- 主体内容 -->
      <div class="eval-content" style="margin-bottom: 40px;">
         <div class="eval-con-top" style="font-size: 14px;">
            <div class="eval-con-title"><span style="font-weight: 700;">丨</span>案件列表</div>
            <div style="display: flex;justify-items: flex-end;margin-left: auto;">
            <!-- <div class="eval-con-btn" style="margin-left: auto;">表格导出</div> -->
            <!-- <div v-if="importEvalBtnAuth" class="eval-con-btn" title="点击查看数据统计" @click="jumpChart()">图表统计</div>
            <div v-if="analysisBtnAuth" class="eval-con-btn" @click="importCaseEval()">案件导出</div> -->
            <div class="eval-con-btn" title="点击查看数据统计" @click="jumpChart()">图表统计</div>
            <div class="eval-con-btn" @click="importCaseEval()">案件导出</div>
            <div class="eval-con-search">
               <el-input v-model="formInline.keyword" clearable placeholder="请输入关键词">
                  <!-- <template slot="append" style="color: #ffffff;">搜索</template> -->
                  <el-button slot="append" style="background-color: #2A91DD;" @click="checkSearch()">搜索</el-button>
               </el-input>
            </div>
         </div>
      </div>
         <div class="eval-table" style="padding-bottom: 10px;">
            <el-table size="small" :data="caseData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" ref="multipleTable" @selection-change="handleSelectionChange">
               <el-table-column align="center" type="selection" width="40" fixed="left">
               </el-table-column>
               <el-table-column align="center" type="index" label="序号" width="60">
               </el-table-column>
               <el-table-column prop="title" align="center" label="专利名称" show-overflow-tooltip>
                  <template slot-scope="scope">
                     <span v-if="evalCaseInfoBtnAuth" style="color: #407AA8;cursor: pointer;" title="查询详情" @click="showEvalCaseInfo(scope.row)">{{ scope.row.title }}</span>
                     <span v-if="!evalCaseInfoBtnAuth">{{ scope.row.title }}</span>
                     <!-- <span style="color: #407AA8;cursor: pointer;">{{ scope.row.title }}</span> -->
                  </template>
               </el-table-column>
               <el-table-column prop="type" align="center" label="专利类型" width="70" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="mainIpc" align="center" label="主分类号" width="90" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="name" align="center" label="用户" width="60" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="mobile" align="center" label="手机号" width="100" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="patentee" align="center" label="专利权人" width="70" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="total_fee" align="center" label="订单金额" width="70" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="points" align="center" label="消耗积分" width="70" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="pay_time" align="center" label="支付时间" width="120" show-overflow-tooltip>
               </el-table-column>
               <el-table-column align="center" label="操作" min-width="60">
                  <template slot-scope="scope">
                     <el-button v-if="scope.row.report_url!=''" size="mini" type="primary" style="background-color: #2A91DD;" title="下载PDF报告" @click="downloadReport(scope.row)">下载</el-button>
                     <!-- <el-button v-if="scope.row.status==4&&scope.row.eval_type==2" size="mini" type="primary" style="background-color: #2A91DD;" title="下载PDF报告" @click="handleDistributeCase(scope.row)">分配</el-button> -->
                  </template>
               </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
         </div>
      </div>
      <!-- 案件详情 技术信息以及评估数据 -->
      <div>
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="evalCaseInfoVisible" width="1200px">
            <!-- <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">{{ title }}</div> -->
            <div>
               <div style="display: flex;">
                  <div class="eval-content-item">
                     <div class="eval-con-top" style="font-size: 14px;">
                        <div class="eval-con-title"><span style="font-weight: 700;">丨</span>案件信息</div>
                     </div>
                     <div style="font-size: 14px;">
                        <div style="display: flex;margin: 10px 60px;">
                           <div style="width: 90px;text-align: left;">预申请名称：</div>
                           <div>{{ evalData.title }}</div>
                        </div>
                        <div style="display: flex;margin: 10px 60px;">
                           <div style="width: 90px;text-align: left;">预申请类型：</div>
                           <div>{{ evalData.type }}</div>
                        </div>
                        <div style="display: flex;margin: 10px 60px;">
                           <div style="width: 90px;text-align: left;">所属领域：</div>
                           <div>{{ evalData.area }}</div>
                        </div>
                        <div style="display: flex;margin: 10px 60px;">
                           <div style="width: 90px;text-align: left;">评测方式：</div>
                           <div v-if="evalData.eval_type == 1">智能评测</div>
                           <div v-if="evalData.eval_type == 2">专家评测</div>
                        </div>
                        <div style="display: flex;margin: 10px 60px;">
                           <div style="width: 90px;text-align: left;">权利要求：</div>
                           <div class="write-area no-select">{{ evalData.claim }}</div>
                        </div>
                        <div style="display: flex;margin: 10px 60px;">
                           <div style="width: 90px;text-align: left;">技术方案：</div>
                           <div class="write-area no-select">{{ evalData.fullText }}</div>
                        </div>
                        <div style="display: flex;margin: 10px 60px;">
                           <div style="width: 90px;text-align: left;">技术摘要：</div>
                           <div class="write-area no-select">{{ evalData.abstract }}</div>
                        </div>
                     </div>
                  </div>
                  <div class="eval-content-item">
                     <div class="eval-con-top" style="font-size: 14px;">
                        <div class="eval-con-title"><span style="font-weight: 700;">丨</span>报告信息</div>
                     </div>
                     <!-- 智能评估内容 -->
                     <div class="eval-content-body" style="height: 510px;overflow-y: auto;">
                        <div v-if="reportData">
                           <table style="width: 100%;border-collapse: collapse;table-layout: fixed;">
                              <tr>
                                 <td colspan="3" style="font-weight: 700;">待申请专利整体评价结果</td>
                              </tr>
                              <tr>
                                 <td colspan="3"style="font-size: 14px;">
                                    您的专利申请综合评价良好，被评为<span style="color: #2A91DD;"> {{ reportData.subItems.level }} </span>级，共计<span style="color: #2A91DD;"> {{ reportData.subItems.starNum }} </span>星(最高15星)
                                 </td>
                              </tr>
                              <tr>
                                 <td colspan="3" style="font-size: 12px;text-align: left;padding: 2px 4px;">
                                    注:综合评价分级表，会对待申请专利进行A至D之间的综合评级，A为最高，D为最低。共计0-15星。综合分级打分的结果，可以便于用户对待申请专利进行分级分类处置。
                                 </td>
                              </tr>
                              <tr>
                                 <td colspan="3" class="table-border" style="background-color: #2A91DD;color: #FFFFFF;">分项评价结果</td>
                              </tr>
                              <tr style="font-size: 14px;">
                                 <td colspan="1" class="table-border">可专利性评价</td>
                                 <td colspan="1" class="table-border">技术竞争</td>
                                 <td colspan="1" class="table-border">市场前景</td>
                              </tr>
                              <tr style="font-size: 14px;">
                                 <td colspan="1" class="table-border" style="color: #2A91DD;">{{ reportData.subItems.viabilityStar }}</td>
                                 <td colspan="1" class="table-border" style="color: #2A91DD;">{{ reportData.subItems.techStar }}</td>
                                 <td colspan="1" class="table-border" style="color: #2A91DD;">{{ reportData.subItems.marketStar }}</td>
                              </tr>
                              <tr>
                                 <td colspan="3" class="table-border" style="background-color: #2A91DD;color: #FFFFFF;">智能评价建议</td>
                              </tr>
                              <tr style="font-size: 12px;">
                                 <td class="table-border" style="text-align: left;padding: 2px 4px;">{{ reportData.subItems.viabilityAdvise }}</td>
                                 <td class="table-border" style="text-align: left;padding: 2px 4px;">{{ reportData.subItems.techAdvise  }}</td>
                                 <td class="table-border" style="text-align: left;padding: 2px 4px;">{{ reportData.subItems.marketAdvise }}</td>
                              </tr>
                              <tr>
                                 <td colspan="3" style="font-size: 12px;text-align: left;padding: 2px 4px;">
                                    注:分项评价表针对待申请专利，从可专利性、技术竞争、市场前景三个方面进行分项评价。
                                 </td>
                              </tr>
                           </table>
                           <table style="border-collapse: collapse;">
                              <tr>
                                 <td colspan="3" class="table-border" style="background-color: #2A91DD;color: #FFFFFF;">综合评价分类结果</td>
                              </tr>
                              <tr v-for="item in reportData.ipcData" style="font-size: 12px;">
                                 <td colspan="1" class="table-border" style="padding: 2px 4px;">{{ item.ipc }}</td>
                                 <td colspan="2" class="table-border" style="text-align: left;padding: 2px 4px;">{{ item.ipcText }}</td>
                              </tr>
                              <tr>
                                 <td colspan="3" style="font-size: 12px;text-align: left;padding: 2px 4px;">
                                    注:综合分类评价表，会对待申请专利进行智能IPC分类。智能分类结果，可以方便用户对待申请专利进行分类管理，并根据不同技术分类，采取不同的申请策略。
                                 </td>
                              </tr>
                           </table>
                           <table style="border-collapse: collapse;width: 100%;margin-top: 10px;table-layout: fixed;text-align: left;">
                              <tr>
                                 <td colspan="3" style="text-align: center;font-weight: 700;">可专利性分析</td>
                              </tr>
                              <tr>
                                 <td colspan="3" style="font-size: 14px;">权利要求项分析</td>
                              </tr>
                              <tr>
                                 <td colspan="3" class="table-border" style="text-align: center;background-color: #2A91DD;color: #FFFFFF;">综合分析表</td>
                              </tr>
                              <tr style="font-size: 12px;">
                                 <td colspan="1" style="border: 1px solid #D3D3D3;padding: 4px;background-color: #F1F1F1;">当前申请的权利要求数量</td>
                                 <td colspan="2" class="table-border" style="">{{ reportData.innovations.claimCnt }}项</td>
                              </tr>
                              <tr style="font-size: 12px;">
                                 <td rowspan="3" colspan="1" style="border: 1px solid #D3D3D3;padding: 4px;background-color: #F1F1F1;">系统判断存在抵触风险的权利要求</td>
                                 <td colspan="2" class="table-border" style="padding: 4px;">{{ reportData.innovations.riskClaimsNum }}项</td>
                              </tr>
                              <tr style="font-size: 12px;">
                                 <td colspan="1" style="border: 1px solid #D3D3D3;padding: 4px;background-color: #F1F1F1;text-align: left;">权项定位</td>
                                 <td colspan="1" class="table-border" style="padding: 4px;">权利要求项{{ reportData.innovations.riskClaimsText }}</td>
                              </tr>
                              <tr style="font-size: 12px;">
                                 <td colspan="1" style="border: 1px solid #D3D3D3;padding: 4px;background-color: #F1F1F1;text-align: left;">综合抵触度</td>
                                 <td colspan="1" class="table-border" style="padding: 4px;">{{ reportData.innovations.riskClaimsScore }}</td>
                              </tr>
                              <tr style="font-size: 12px;">
                                 <td rowspan="3" colspan="1" style="border: 1px solid #D3D3D3;padding: 4px;background-color: #F1F1F1;">系统判定低风险的权利要求</td>
                                 <td colspan="2" class="table-border">{{ reportData.innovations.lowRiskClaimsNum }}项</td>
                              </tr>
                              <tr style="font-size: 12px;">
                                 <td colspan="1" style="border: 1px solid #D3D3D3;padding: 4px;background-color: #F1F1F1;text-align: left;">权项定位</td>
                                 <td colspan="1" class="table-border" style="padding: 4px;">权利要求项{{ reportData.innovations.lowRiskClaimsText }}</td>
                              </tr>
                              <tr style="font-size: 12px;">
                                 <td colspan="1" style="border: 1px solid #D3D3D3;padding: 4px;background-color: #F1F1F1;text-align: left;">综合风险度</td>
                                 <td colspan="1" class="table-border" style="padding: 4px;">{{ reportData.innovations.lowRiskClaimsScore }}</td>
                              </tr>
                              <tr style="font-size: 12px;">
                                 <td colspan="1" style="border: 1px solid #D3D3D3;padding: 4px;background-color: #F1F1F1;">主权利要求项抵触风险</td>
                                 <td colspan="2" class="table-border" style="padding: 4px;">{{ reportData.innovations.claimRisk }}</td>
                              </tr>
                              <tr>
                                 <td colspan="3" style="font-size: 12px;">注:权利要求项分析主要侧重于综合性的给出待申请专利各个权利要求项的抵触风险程度。表中会注明高抵触风险的权利要求项数量，以及定位具体的权利要求项。表中还会同样标出低风险的权利要求项。同时，表中会单独给出主权利要求项的抵触风险。这些抵触风险全部用百分比显示，用于提供给用户，综合判断待申请专利的权利要求项创新性。便于后续调整申请策略。</td>
                              </tr>
                              <tr>
                                 <td colspan="3" class="table-border" style="text-align: center;background-color: #2A91DD;color: #FFFFFF;">权利要求项抵触排查表</td>
                              </tr>
                              <tr>
                                 <td colspan="1" class="table-border" style="padding: 4px;font-size: 14px;">权利要求项</td>
                                 <td colspan="2" class="table-border" style="padding: 4px;font-size: 14px;">疑似对比专利</td>
                              </tr>
                              <tr v-for="item in reportData.innovations.claimConflict" style="font-size: 12px;">
                                 <td colspan="1" class="table-border" style="padding: 4px;">权利要求{{ item.claimKey }}</td>
                                 <td colspan="2" class="table-border" style="padding: 4px;">{{ item.pn }}&nbsp;&nbsp;{{ item.ti }}</td>
                              </tr>
                              <tr>
                                 <td colspan="3" style="font-size: 12px;">注:权利要求项抵触排查表给出了高抵触风险的权利要求项以及对应的相似专利。提供该表的作用，在于提醒用户针对这些专利进行逐项排查，确定对应权利要求项是否存在新颖性或创造性，以便在后续申请中进行调整。</td>
                              </tr>
                              <tr>
                                 <td colspan="3" class="table-border" style="text-align: center;background-color: #2A91DD;color: #FFFFFF;">疑似对比文献表</td>
                              </tr>
                              <tr>
                                 <td colspan="1" class="table-border" style="padding: 4px;font-size: 14px;">疑似对比文献号</td>
                                 <td colspan="1" class="table-border" style="padding: 4px;font-size: 14px;">专利名称</td>
                                 <td colspan="1" class="table-border" style="padding: 4px;font-size: 14px;">可能影响的权利要求项</td>
                              </tr>
                              <tr style="font-size: 12px;" v-for="item in reportData.innovations.docFeature">
                                 <td colspan="1" class="table-border" style="padding: 4px;">{{ item.pn }}</td>
                                 <td colspan="1" class="table-border" style="padding: 4px;">{{ item.ti }}</td>
                                 <td colspan="1" class="table-border" style="padding: 4px;">{{ item.claims }}</td>
                              </tr>
                              <tr>
                                 <td colspan="3" style="font-size: 12px;">注:疑似对比文献表，给出了可能会影响当前专利新颖性和创造性的专利文献列表。建议用户对该表中列出的疑似对比文献进行通读和排查，进一步判断待申请专利的可专利性。</td>
                              </tr>
                              <tr>
                                 <td colspan="3" style="text-align: left;font-size: 14px;font-weight: 700;padding:4px 0px;">相似专利列表（5）</td>
                              </tr>
                           </table>
                           <div>
                              <div v-for="(item,index) in reportData.patents" style="font-size: 12px;text-align: left;margin-top: 10px;">
                                 <div>
                                    <span style="font-weight: 700;">{{ index+1 }}.{{ item.ti }}</span>
                                    <span style="margin-left: 30px;background-color: #2A91DD;padding: 2px 4px;border-radius: 4px;color: #FFFFFF;">{{ item.type }}</span>
                                 </div>
                                 <div style="color: #2A91DD;display: flex;margin-top: 4px;font-weight: 700;">
                                    <div style="width: 50%;">
                                       <span>可能影响的权利要求项：</span>
                                       <span v-if="item.claims.length > 0" v-for="itemI in item.claims">{{ itemI }}</span>
                                       <span v-if="item.claims.length <= 0">-</span>
                                    </div>
                                    <div style="width: 50%;">
                                       <span>专利相似度：</span>
                                       <span>{{ item.relevance }}</span>
                                    </div>
                                 </div>
                                 <div style="color: #2A91DD;display: flex;margin-top: 4px;">
                                    <div style="width: 50%;">
                                       <span style="font-weight: 700;">申请号：</span>
                                       <span>{{ item.an }}</span>
                                    </div>
                                    <div style="width: 50%;">
                                       <span style="font-weight: 700;">申请日：</span>
                                       <span>{{ item.ad }}</span>
                                    </div>
                                 </div>
                                 <div style="color: #2A91DD;display: flex;margin-top: 4px;">
                                    <div style="width: 50%;">
                                       <span style="font-weight: 700;">公开号：</span>
                                       <span>{{ item.pn }}</span>
                                    </div>
                                    <div style="width: 50%;">
                                       <span style="font-weight: 700;">公开日：</span>
                                       <span>{{ item.pd }}</span>
                                    </div>
                                 </div>
                                 <div style="margin-top: 4px;">
                                    <span style="font-weight: 700;">国际分类号：</span>
                                    <span>{{ item.ipcText }}</span>
                                 </div>
                                 <div style="margin-top: 4px;">
                                    <span style="font-weight: 700;">申请（专利权）人：</span>
                                    <span>{{ item.applicantText }}</span>
                                 </div>
                                 <div style="margin-top: 4px;">
                                    <span style="font-weight: 700;">发明（设计）人：</span>
                                    <span>{{ item.inventorText }}</span>
                                 </div>
                                 <div style="margin-top: 4px;font-weight: 700;">摘要</div>
                                 <div><span style="color: #FFFFFF;">占位</span>{{ item.abs }}</div>
                              </div>
                           </div>
                        </div>
                        <div v-else>
                           暂无报告信息，请等待系统生成
                        </div>
                     </div>
                  </div>
               </div>
               <!-- 附图数据 -->
               <div v-if="figureData&&figureData.length>0" class="eval-content-item" style="background-color: #FFFFFF;width: 1160px;margin-top: 10px;">
                  <div class="eval-con-top" style="font-size: 14px;">
                     <div class="eval-con-title"><span style="font-weight: 700;">丨</span>相关附图</div>
                  </div>
                  <div style="display: flex;margin: 0px 40px;padding-bottom: 10px;">
                     <img v-for="item in figureData" :src="item.pre_figure_url" class="figure-img" @click="preview(item)"/>
                  </div>
               </div>
               <!-- 专家评估 -->
               <div v-if="evalData.result&&evalData.result.length>0" class="eval-content-item" style="background-color: #FFFFFF;width: 1160px;margin-top: 10px;">
                  <div class="eval-con-top" style="font-size: 14px;">
                     <div class="eval-con-title"><span style="font-weight: 700;">丨</span>专家建议</div>
                  </div>
                  <div style="margin: -10px 20px;">
                     <div style="text-align: left;margin-top: 20px;">
                        <div style="padding: 4px 20px;">检索策略</div>
                        <div style="border: 1px solid #DCDFE6;border-radius: 4px;padding: 4px 10px;margin: 0px 20px;">{{ evalData.strategy }}</div>
                     </div>
                     <div style="text-align: left;">
                        <div style="padding: 4px 20px;">检索表达式</div>
                        <div style="border: 1px solid #DCDFE6;border-radius: 4px;padding: 4px 10px;margin: 0px 20px;">{{ evalData.expression }}</div>
                     </div>
                     <div style="text-align: left;">
                        <div style="padding: 4px 20px;">检索结果</div>
                        <div style="border: 1px solid #DCDFE6;border-radius: 4px;padding: 4px 10px;margin: 0px 20px;white-space: pre-line;">{{ evalData.result }}</div>
                     </div>
                     <div style="text-align: left;">
                        <div style="padding: 4px 20px;">检索分析</div>
                        <div style="border: 1px solid #DCDFE6;border-radius: 4px;padding: 4px 10px;margin: 0px 20px;white-space: pre-line;">{{ evalData.analysis }}</div>
                     </div>
                     <div style="text-align: left;">
                        <div style="padding: 4px 20px;">申请建议</div>
                        <div style="border: 1px solid #DCDFE6;border-radius: 4px;padding: 4px 10px;margin: 0px 20px;">{{ evalData.suggestion }}</div>
                     </div>
                     <div style="text-align: left;">
                        <div style="padding: 4px 20px;">评估专家</div>
                        <div style="border: 1px solid #DCDFE6;border-radius: 4px;padding: 4px 10px;margin: 0px 20px;">{{ evalData.agent_name }}</div>
                     </div>
               </div>
               </div>
            </div>
         </el-dialog>
       </div>
       <!-- 图片预览 -->
      <el-dialog :visible.sync="dialogVisible">
         <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>

      <!-- 案件分配 -->
      <div>
         <el-dialog title="案件分配" :visible.sync="dialogVisibleDistributeCase" v-dialogDrag :close-on-click-modal="false" width="800px">
            <div style="text-align: left;border-radius: 4px;border: 1px solid #2A91DD;padding: 4px 10px;margin-top: -20px;">
               <div>标题：{{ distributeCaseData.title }}</div>
               <div>领域：{{ distributeCaseData.area }}</div>
            </div>
            <div style="display: flex;margin-top: 10px;">
               <el-select v-model="distributeFormline.area" placeholder="请选择领域" clearable style="width: 120px;margin-left: auto;margin-right: 10px;">
                  <el-option label="机械" value="机械"></el-option>
                  <el-option label="电学" value="电学"></el-option>
                  <el-option label="通信" value="通信"></el-option>
                  <el-option label="生物" value="生物"></el-option>
                  <el-option label="光电" value="光电"></el-option>
                  <el-option label="化学" value="化学"></el-option>
                  <el-option label="材料" value="材料"></el-option>
               </el-select>
               <el-input v-model.trim="distributeFormline.name" clearable placeholder="请输入姓名" style="width: 180px;margin-right: 10px;"></el-input>
               <el-input v-model.trim="distributeFormline.agency_name" clearable placeholder="请输入机构" style="width: 180px;margin-right: 10px;"></el-input>
               <el-button type="primary" @click="getDistributeCaseAgentData()" style="margin-right: 0px;background-color: #2A91DD;">搜索</el-button>
            </div>
            <div class="eval-table" style="padding-bottom: 10px;width: 100%;padding-top: 10px;">
               <el-table size="small" :data="distributeAgentData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" height="450" style="width: 100%;">
                  <!-- <el-table-column align="center" type="selection" width="40" fixed="left">
                  </el-table-column> -->
                  <el-table-column align="center" type="index" label="序号" width="60">
                  </el-table-column>
                  <el-table-column prop="name" align="center" label="姓名" width="80" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="area" align="center" label="领域" width="80" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="agency_name" align="center" label="所属机构" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="caseNum" align="center" label="待评估数量" width="120" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column align="center" label="操作" width="120">
                     <template slot-scope="scope">
                        <el-button size="mini" title="分配案件" type="primary" style="background-color: #2A91DD;" @click="distributeCase(scope.row)">分配</el-button>
                     </template>
                  </el-table-column>
               </el-table>
            </div>
         </el-dialog>
      </div>
    </div>
 </template>
 <script>
   import { 
      getSysCasePageList,
      importEvalCaseCheck,
      getCusEvalCaseData,
      getSysAdminEvalReport,
      getDistributeAgentList
   } from '../../api/evalMG'
   import Pagination from '../../components/Pagination'
   import topInfo from '../../components/topInfo'
   import sysNav from '../../components/sysNav'
   import { checkLogin } from '../../utils/util'
   export default {
      data() {
         return {
            // 按钮权限开始
            importEvalBtnAuth: false,
            analysisBtnAuth: false,
            evalCaseInfoBtnAuth: false,
            downloadReportBtnAuth: false,
            evalCaseInfoVisible: false,
            // 按钮权限结束
            loading: false,
            caseData: [],
            formInline: {
               page: 1,
               ps: 10,
               keyword: ''
            },
            figureData: [],
            evalData: [],
            reportData: {
               abnormal: {},
               patents: {},
               subItems: {
                  allValue: '',
                  coupling: '',
                  damping: '',
                  depth: '',
                  level: '',
                  market: '',
                  maxValue: '',
                  operating: '',
                  tech: '',
                  viability: '',
               },
               ipcInfo: [
                  {
                     name: '',
                     value: ''
                  }
               ],
               innovations: {
               }
            },
            // 查询分配专利参数
            distributeFormline: {
               area: '',
               name: '',
               agency_name: ''
            },
            dialogVisible: false,
            dialogVisibleDistributeCase: false,
            dialogImageUrl: '',

            // 分配专家
            distributeAgentData: [],
            // 待分配案件详情
            distributeCaseData: [],

            multipleSelection: [], //列表勾选框值
            // 分页参数
            pageparm: {
               currentPage: 1,
               pageSize: 10,
               total: 10
            }
         }
      },
      // 注册组件
      components: {
         Pagination,
         topInfo,
         sysNav
      },
      created(){
         let btnAuth = JSON.parse(localStorage.getItem('btnAuth'))
         if(btnAuth.includes("importEvalBtn")){
            this.importEvalBtnAuth = true
         }
         if(btnAuth.includes("analysisBtn")){
            this.analysisBtnAuth = true
         }
         if(btnAuth.includes("evalCaseInfoBtn")){
            this.evalCaseInfoBtnAuth = true
         }
         if(btnAuth.includes("downloadReportBtn")){
            this.downloadReportBtnAuth = true
         }
         this.getCaseData()
      },
      methods: {
         checkType(val){
            this.applyForm.type = val
         },
         checkArea(val){
            this.applyForm.area = val
         },
         // 跳转客户管理
         jumpCustomer(){
            this.$router.push({ path: '/system/customer'});
         },
         // 跳转账户管理
         jumpAccount(){
            this.$router.push({ path: '/system/account'});
         },
         // 跳转案件管理
         jumpCase(){
            this.$router.push({ path: '/system/case'});
         },
         // 跳转个人中心
         jumpPersonCenter(){
            this.$router.push({ path: '/system/personCenter'});
         },
         // 点击搜索
         checkSearch(){
            this.getCaseData()
         },
         // 查询案件数据
         getCaseData(){
            this.loading = true
            getSysCasePageList(this.formInline)
            .then(res=>{
               res = checkLogin(res);
                if(!res){
                 this.$message({
                   type: 'warning',
                   message: '登录已失效,请重新登录!'
                 }) 
                  // 登陆已失效 清除登陆状态
                  setTimeout(() => {
                     window.localStorage.removeItem('userToken');
                     window.localStorage.removeItem('sign');
                     window.localStorage.removeItem('userData');
                     this.$router.push({ path: '/login'});
                     }, 1000)
                }
               if(res.code == 200){
                  this.caseData = res.data.dataList
                  this.pageparm.currentPage = this.formInline.page
                  this.pageparm.pageSize = this.formInline.ps
                  this.pageparm.total = res.data.total
                  this.loading = false
               }else{
                  this.$message({
                     type: 'warning',
                     message: res.msg
                  })
                  this.loading = false
               }
            })
         },
         // 监听数据列表复选框是否选择
         handleSelectionChange(val){
            this.multipleSelection = val;
         },
         // 案件导出
         importCaseEval(){
            let checkIds = this.multipleSelection
            if(checkIds.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '暂无勾选的数据!'
               })
               return false
            }
            this.$confirm('确定导出勾选的案件吗?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            })
            .then(()=>{
               let idArr = []
               checkIds.forEach((item,index)=>{
                  idArr.push(item.id)
               })
               let ids = JSON.stringify(idArr)
               importEvalCaseCheck({ids})
               .then(res=>{
                  if(res.code == 200){
                     this.$message({
                        type: 'success',
                        message: res.msg
                     })
                     window.location.href = res.data.url
                  }else{
                     this.$message({
                        type: 'error',
                        message: res.msg
                     })
                  }
               })
            })
            .catch(() => {
               this.$message({
                  type: 'info',
                  message: '已取消'
               })
            })
         },
         // 跳转图表
         jumpChart(){
            let {href} =  this.$router.resolve('/system/platformChart')
            window.open(href,'_blank')
         },
         // 查看案件详情
         showEvalCaseInfo(val){
            console.log(val)
            this.title = '案件详情'
            // 查询案件详情
            let param = {
               id: val.id
            }
            getCusEvalCaseData(param)
            .then(res=>{
               if(res.code == 200){
                  this.evalData = res.data.evalData
                  let report_data = res.data.reportData
                  if(report_data&&report_data.subItems){
                     this.reportData = res.data.reportData
                     this.figureData = res.data.figureData
                  }else{
                     this.reportData = false
                  }
                  this.evalCaseInfoVisible = true
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  })
               }
               
            })
            
         },
         // 下载PDF报告
         downloadReport(val){
            if(val.report_url == ''){
               this.$message({
                  type: 'warning',
                  message: '报告还未生成,请稍后再试!'
               })
               return false
            }
            let url = val.report_url
            window.open(url)
         },

         // 显示案件分配页面(专家列表)
         handleDistributeCase(val){
            console.log(val)
            this.distributeFormline.area = val.area
            this.distributeFormline.name = ''
            this.distributeFormline.agency_name = ''
            this.distributeCaseData = val
            this.getDistributeCaseAgentData()
         },
         // 查询专家列表(分配)
         getDistributeCaseAgentData(){
            getDistributeAgentList(this.distributeFormline)
            .then(res=>{
               if(res.code == 200){
                  this.distributeAgentData = res.data
                  this.dialogVisibleDistributeCase = true
               }else{
                  this.$message({
                     type: 'error',
                     message: '专家分配列表获取失败,请稍后再试!'
                  })
               }
            })
         },
         // 分配案件
         distributeCase(val){
            let agent_id = val.id
            let num = val.caseNum
            let name = val.name
            let case_id = this.distributeCaseData.id
            if(num > 0){
               this.$message({
                  type: 'warning',
                  message: '专家有未评估案件,暂不能分配!'
               })
               return false
            }
            // 询问是否分配
            this.$confirm('确定将分配给'+name+'吗？', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            })
            .then(()=>{
               // 分配案件
               let param = {
                  agent_id: agent_id,
                  case_id: case_id
               }
               distributeCaseToAgent(param)
               .then(res=>{
                  if(res.code == 200){
                     this.$message({
                        type: 'success',
                        message: res.msg
                     })
                     this.dialogVisibleDistributeCase = false
                     this.getCaseData()
                  }else{
                     this.$message({
                        type: 'error',
                        message: res.msg
                     })
                  }
               })
            })
            .catch(() => {
               this.$message({
                  type: 'info',
                  message: '已取消'
               })
            })
         },
         // 预览附图
         preview(val){
            let url = val.pre_figure_url
            this.dialogImageUrl = url
            this.dialogVisible = true
         },
         // 分页插件事件
         callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.ps = parm.pageSize
            this.getCaseData()
         },
      }
   }
</script>
<style scoped>
  .login-page {
    text-align: center;
    /* height: 100%; */
  }
  .login-title {
    font-size: 44px;
    font-weight: 700;
    padding-top: 24px;
  }
  .login-title-en {
    font-size: 16px;
    color: #5a5a5a;
    margin-top: 10px;
  }
  .eval-content {
   width: 1200px;
   /* height: 600px; */
   margin: 0px auto;
   background-color: #fff;
   border-radius: 10px;
  }
  .eval-con-top {
   display: flex;
   margin: 10px 40px;
   padding: 16px 0px;
   /* border-bottom: 2px solid #eeeeee; */
  }
  .eval-con-title {
   color: #2A91DD;
   height: 36px;
   line-height: 36px;
   font-size: 16px;
   font-weight: 700;
  }
  .eval-con-btn {
   width: 100px;
   height: 36px;
   line-height: 36px;
   text-align: center;
   color: #fff;
   background-color: #2A91DD;
   border-radius: 5px;
   margin-left: 20px;
   cursor: pointer;
  }
  .eval-con-search {
   margin-left: 20px;
  }
  .eval-con-search>>>.el-input-group {
   border-radius: 10px !important;
  }
  .eval-con-search>>>.el-input-group__append, .el-input-group__prepend {
   color: #FFFFFF;
   background-color: #2A91DD;
   cursor: pointer;
  }
  .eval-con-search>>>.el-input__inner {
   background-color: #F3F3F3 !important;
   border: none;
  }
  .eval-table {
   width: 1120px;
   margin: 0px auto;
  }
  .eval-table>>> .el-table__header th {
   background-color: #2A91DD !important;
  }
  .eval-table>>> .el-table thead {
   color: #FFFFFF;
  }
  .eval-content-item {
   width: 590px;
   border-radius: 10px;
   background-color: #fff;
  }
  .eval-con-top {
   display: flex;
   margin: 10px 40px;
   padding: 16px 0px;
   border-bottom: 2px solid #eeeeee;
  }
  .eval-con-title {
   color: #2A91DD;
   height: 36px;
   line-height: 36px;
   font-size: 16px;
   font-weight: 700;
  }
  .eval-content-body {
   margin: 10px 60px;
  }
  .write-area {
   width: 360px;
   text-align:left;
   height: 120px;
   overflow-y: auto;
   padding: 2px 4px;
   border: 1px solid #F3F3F3;
  }
  .table-border {
   border: 1px solid #f3f3f3;
  }
  .no-select {
   -webkit-user-select: none; 
   -moz-user-select: none; 
   -ms-user-select: none; 
   user-select: none;
  }
  .figure-img {
   width: 120px;
   height: 120px;
   margin-right: 10px;
   border: 1px solid #c0ccda;
   border-radius: 6px;
   cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/views/system/case.vue